class DropdownOption {
  constructor (
    label,
    key,
    iconName,
    iconSize,
    iconColor,
    clickEvent,
    internalNavigation
  ) {
    this.label = label
    this.key = key
    this.iconName = iconName
    this.iconSize = iconSize
    this.iconColor = iconColor
    this.clickEvent = clickEvent
    this.internalNavigation = internalNavigation
  }
}
export const programContactOptions = (contact) => {
  const actionArray = []
  if (contact?.email) {
    actionArray.push(
      new DropdownOption(
        `Email ${contact?.first_name}`,
        'email',
        'Email',
        21,
        'lightBaseIcon',
        `mailto:${contact?.email}`,
        false
      )
    )
  }
  if (contact?.phone) {
    actionArray.push(
      new DropdownOption(
        `Call ${contact?.first_name}`,
        'phone',
        'Phone',
        21,
        'lightBaseIcon',
        `tel:${contact?.phone}`,
        false
      )
    )
  }
  if (contact?.phone_mobile) {
    actionArray.push(
      new DropdownOption(
        `Text ${contact?.first_name}`,
        'text',
        'Message',
        21,
        'lightBaseIcon',
        `sms:${contact?.phone_mobile}`,
        false
      )
    )
  }
  if (contact?.linkedin_profile) {
    actionArray.push(
      new DropdownOption(
        `View ${contact?.first_name}'s LinkedIn`,
        'linkedin',
        'Application-LinkedIn',
        21,
        'lightBaseIcon',
        `${contact?.linkedin_profile}`,
        false
      )
    )
  }
  return actionArray
}
export const photoEditingOptions = () => {
  const actionArray = []
  actionArray.push(
    // new DropdownOption(
    //   'Edit current profile photo',
    //   'editor',
    //   'Control-EditIcon-BlueOutline',
    //   20,
    //   'lightBaseIcon',
    //   '/edit-photo/editor',
    //   true
    // ),
    new DropdownOption(
      'Upload from photos',
      'upload',
      'Image',
      20,
      'lightBaseIcon',
      '/edit-photo/upload',
      true
    ),
    new DropdownOption(
      'Take a photo',
      'camera',
      'Camera',
      20,
      'lightBaseIcon',
      '/edit-photo/camera',
      true
    )
  )
  return actionArray
}
